// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"f488c316","383":"d42906d7","457":"da1546bd","488":"b31f89e4","542":"f6828d45","588":"19d446c8","678":"db19de5e","773":"3f80fdab","805":"bf5faad7","846":"f286b2e1","873":"e45195ae"}[chunkId] + ".chunk.js";
};